var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 90,
    viewBox: "0 0 103 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.728 61.264V58.128C83.728 49.488 93.968 47.504 93.968 41.296C93.968 38.8 91.984 36.496 88.592 36.496C85.072 36.496 83.6 38.8 82.896 40.464L75.856 37.328C77.072 33.808 80.72 28.368 88.72 28.368C96.976 28.368 102.992 33.488 102.992 40.784C102.992 50.384 92.304 52.432 92.304 58.64V61.264H83.728ZM88.016 74.832C84.944 74.832 82.576 72.4 82.576 69.456C82.576 66.448 84.944 63.952 88.016 63.952C91.088 63.952 93.456 66.448 93.456 69.456C93.456 72.4 91.088 74.832 88.016 74.832Z",
    fill: "url(#paint0_linear_5857_23293)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.728 59.264V56.128C81.728 47.488 91.968 45.504 91.968 39.296C91.968 36.8 89.984 34.496 86.592 34.496C83.072 34.496 81.6 36.8 80.896 38.464L73.856 35.328C75.072 31.808 78.72 26.368 86.72 26.368C94.976 26.368 100.992 31.488 100.992 38.784C100.992 48.384 90.304 50.432 90.304 56.64V59.264H81.728ZM86.016 72.832C82.944 72.832 80.576 70.4 80.576 67.456C80.576 64.448 82.944 61.952 86.016 61.952C89.088 61.952 91.456 64.448 91.456 67.456C91.456 70.4 89.088 72.832 86.016 72.832Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 30L31.0062 29.9964C25.1456 29.9695 20.5873 28.7882 17.4569 26.4793C12.556 22.8672 12.9979 17.8479 13.0189 17.6364L13.0764 17.0538L13.9316 17.0125C13.9316 17.0125 14.1722 17 14.5958 17C17.483 17 31.8849 17.5951 31.9948 29.3188L32 30Z",
    fill: "url(#paint1_linear_5857_23293)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9987 24.0006L33.4742 23.3662C30.3804 19.6254 29 20 28 14C27.5 9.5 27.5005 7.5 27.5 5.5L27.5002 0L28.4988 0.5C28.6756 0.680928 35.4161 4.50061 36.992 11.5142C37.7265 14.7835 38 18.5 34.5251 23.3662L33.9987 24.0006Z",
    fill: "url(#paint2_linear_5857_23293)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5645 31.4437L35.5419 30.559C35.1304 15.3337 47.9006 14.133 50.4635 14.0473C50.8423 14.0346 51.0566 14.0438 51.0566 14.0438L51.8159 14.072L51.8946 14.8266C51.9224 15.1007 52.5329 21.6023 48.3354 26.4402C45.6567 29.531 41.6556 31.2004 36.4473 31.4095L35.5645 31.4437Z",
    fill: "url(#paint3_linear_5857_23293)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7486 90L41.4473 30.012C41.2922 30 41.1396 30 40.9845 30H25.5L14.8013 90H30.7486ZM10.8329 90H14.8013L25.5 30.012H25.4132C18.9964 30.012 13 35.5 10.9005 43.2634L0.0321748 76.7636C-0.443825 84.0336 4.41874 90 10.8329 90ZM34.1648 90C40.5816 90 43.5 84.5 44.9682 76.7486L51.4946 43.2514C52 34.5 47.6537 30.2907 41.4368 30.012L30.7381 90H34.1648Z",
    fill: "#F7D95C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 33C37.3564 33 34 36.804 34 41.5C34 46.1939 37.3564 50 41.5 50C45.6416 50 49 46.1939 49 41.5C49 36.804 45.6416 33 41.5 33Z",
    fill: "#F5F5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 33C19.3564 33 16 36.804 16 41.5C16 46.1939 19.3564 50 23.5 50C27.6416 50 31 46.1939 31 41.5C31 36.804 27.6416 33 23.5 33Z",
    fill: "#F5F5F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9095 52C26.766 52 24.077 54.5 21.9096 61C19.909 67 21.2667 72 25.4102 72C29.5519 72 33.2557 69.5 35.409 62.5C37.4084 56 36.409 52.0002 30.9095 52Z",
    fill: "#263238"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3585 67.2066C33.351 63.8992 31.6982 62.0001 27.9089 62C24.9946 62 22.7998 63.2367 21 66.2321C21.0355 69.6469 22.567 72 25.4096 72C28.4384 72 31.2332 70.6629 33.3585 67.2066Z",
    fill: "#FC6362"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5009 35C41.0144 35 39 37.462 39 40.5011C39 43.538 41.0144 46 43.5009 46C45.9856 46 48 43.538 48 40.5011C48 37.462 45.9856 35 43.5009 35Z",
    fill: "#492523"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5009 35C23.0144 35 21 37.462 21 40.5011C21 43.538 23.0144 46 25.5009 46C27.9856 46 30 43.538 30 40.5011C30 37.462 27.9856 35 25.5009 35Z",
    fill: "#492523"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41C45 39.8383 45.865 39.0009 47 39.0009C45.9177 39.0009 45.0009 38.1089 45.0009 37.0009C45.0009 38.0983 44.1453 39.0009 43 39.0009C44.1453 39.0009 45 39.8805 45 41Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45 37L45.0009 37.0009M45.0009 37.0009C45.0009 38.1089 45.9177 39.0009 47 39.0009C45.865 39.0009 45 39.8383 45 41C45 39.8805 44.1453 39.0009 43 39.0009C44.1453 39.0009 45.0009 38.0983 45.0009 37.0009Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27 41C27 39.8383 27.865 39.0009 29 39.0009C27.9177 39.0009 27.0009 38.1089 27.0009 37.0009C27.0009 38.0983 26.1453 39.0009 25 39.0009C26.1453 39.0009 27 39.8805 27 41Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27 37L27.0009 37.0009M27.0009 37.0009C27.0009 38.1089 27.9177 39.0009 29 39.0009C27.865 39.0009 27 39.8383 27 41C27 39.8805 26.1453 39.0009 25 39.0009C26.1453 39.0009 27.0009 38.0983 27.0009 37.0009Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5857_23293",
    x1: 74,
    y1: 29,
    x2: 130.327,
    y2: 33.5863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5857_23293",
    x1: 22.5,
    y1: 17,
    x2: 22.5,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5857_23293",
    x1: 34,
    y1: 0.000976563,
    x2: 34,
    y2: 24.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5857_23293",
    x1: 43.4419,
    y1: 14.2821,
    x2: 44.0064,
    y2: 31.1614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.250478102b71913a0209e99b5e72a7fb.svg";
export { ForwardRef as ReactComponent };